import { SITE_NAME } from "@api/constants";
import { NextSeo } from "next-seo";
import React from "react";

import Container from "@components/Container";
import MainLayout from "@components/MainLayout";
import PrivacyPolicy from "@components/PrivacyPolicy";
import Title from "@components/Title";

const PrivacyPage = () => (
  <Container>
    <NextSeo title={`Privacy Policy | ${SITE_NAME}`} />
    <Title>Privacy Policy</Title>
    <PrivacyPolicy />
  </Container>
);

PrivacyPage.Layout = MainLayout;

export default PrivacyPage;
